import { useRef } from 'react';
import { Paper, PaperProps } from '@mui/material';
import Draggable from 'react-draggable';

function DraggableComponent(props: PaperProps) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      nodeRef={nodeRef}
      bounds="body"
    >
      <Paper ref={nodeRef} data-testid="draggable-component" {...props} />
    </Draggable>
  );
}

export default DraggableComponent;
